import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as AppStoreIcon } from '../../../../assets/images/apps/AppStore.svg';
import { ReactComponent as AppStoreLightIcon } from '../../../../assets/images/apps/AppStoreLight.svg';
import { ReactComponent as GooglePlayIcon } from '../../../../assets/images/apps/GooglePlay.svg';
import { ReactComponent as FacebookIcon } from '../../../../assets/images/apps/Facebook.svg';
import { ReactComponent as InstaIcon } from '../../../../assets/images/apps/Insta.svg';
import { ReactComponent as ViberIcon } from '../../../../assets/images/apps/Viber.svg';
import { ReactComponent as TelegramIcon } from '../../../../assets/images/apps/Telegram.svg';
import { ReactComponent as SpeedTestIcon } from '../../../../assets/images/apps/SpeedTest.svg';
import { useAppSelector } from '../../../../hooks/redux';

export const Socials: FC = () => {
  const { t, i18n } = useTranslation();
  const { theme } = useAppSelector((state) => state.appReducer);

  return (
    <div className="socials">
      <div className="socials__apps">
        <p className="socials__title">{t('header.myBrizApp')}</p>
        <p className="socials__text">{t('header.personalAccountInYourSmartphone')}</p>
        <div className="socials__icons">
          <div className="socials__icons__link">
            <a
              href={
                process.env.REACT_APP_MY_BRIZ_APPLE ? `${process.env.REACT_APP_MY_BRIZ_APPLE}?l=${i18n.language}` : ''
              }
              target="_blank"
              rel="noreferrer"
            >
              {theme === 'light' ? <AppStoreLightIcon /> : <AppStoreIcon />}
            </a>
          </div>
          <div className="socials__icons__link">
            <a
              href={
                process.env.REACT_APP_MY_BRIZ_ANDROID
                  ? `${process.env.REACT_APP_MY_BRIZ_ANDROID}&hl=${i18n.language}`
                  : ''
              }
              target="_blank"
              rel="noreferrer"
            >
              <GooglePlayIcon />
            </a>
          </div>
        </div>
      </div>
      <div className="socials__social-links">
        <p className="socials__title">{t('header.weAreInSocials')}</p>
        <p className="socials__text">{t('header.newsAndPromotionsDetails')}</p>
        <div className="socials__icons">
          <div className="socials__icons__link">
            <a href="https://www.instagram.com/briz_official/" target="_blank" rel="noreferrer">
              <InstaIcon />
            </a>
          </div>
          <div className="socials__icons__link">
            <a href="https://www.facebook.com/brizodessa/" target="_blank" rel="noreferrer">
              <FacebookIcon />
            </a>
          </div>
          <div className="socials__icons__link">
            <a
              href="https://invite.viber.com/?g2=AQBP6T8C0GnSf0zICnMwJglZHVgGiKRa7zlioveG8yysTGbXk39nRbU14kQCy1Wm"
              target="_blank"
              rel="noreferrer"
            >
              <ViberIcon />
            </a>
          </div>
          <div className="socials__icons__link">
            <a href="https://t.me/brizinfo" target="_blank" rel="noreferrer">
              <TelegramIcon />
            </a>
          </div>
        </div>
      </div>
      <div className="socials__speed-test">
        <p className="socials__title">{t('header.speedCheck')}</p>
        <div className="socials__icons hover">
          <a href="https://ispbriz.speedtestcustom.com/" target="_blank" rel="noreferrer">
            <SpeedTestIcon />
          </a>
        </div>
      </div>
    </div>
  );
};
